// Work Experience and Projects Data

export interface WorkExperience {
    id: number;
    type: 'job' | 'project';
    title: string;
    company?: string;
    location?: string;
    period?: string;
    description: string;
    link?: string;
    github?: string;
}

export const myData: WorkExperience[] = [
    {
        id: 1,
        type: 'job',
        title: "Software Engineer",
        company: "Shared Spectrum Company",
        location: "Virginia, USA",
        period: "Present",
        description: `Working at a leading spectrum sharing solutions company specializing in Dynamic Spectrum Access (DSA) and cognitive radio technologies. SSC develops systems enabling efficient allocation and dynamic access to radio frequency spectrum for mission-critical applications.

Key responsibilities include developing software for ATAK (Android Team Awareness Kit) plugins and accompanying spectrum management tools, as well as spectrum sensing and situational awareness systems. Working with defense and government sector clients including DoD, DARPA, and major defense contractors.

The company has over 20 years of experience with 100+ completed projects and 25+ patents in spectrum sharing technologies.`,
        link: "https://www.sharedspectrum.com/"
    },
    {
        id: 2,
        type: 'job',
        title: "Software Engineer",
        company: "Iwork Technologies PLC",
        location: "Addis Ababa, Ethiopia",
        period: "2020 - 2023",
        description: `Developed Sparta ERP - a multi-purpose enterprise resource planning software custom-made for companies to manage business operations and customer relationships. The web-based application includes Finance Management, HR, Inventory, Sales, Purchase, Production, Project Management, and CRM modules. Added modules for POS, Payroll, Warehouse Management, Quality Control, and Asset Management per client requirements.`,
        link: "https://www.iworkplc.com/"
    },
    {
        id: 3,
        type: 'project',
        title: "Debut",
        description: `A digital platform helping founders mobilize their network (family, friends, extended connections) to launch their startup or project. Think "baby-shower for your startup".`,
        link: "https://debutco.app/",
        github: "https://github.com/AbrahamTerfie"
    },
    {
        id: 4,
        type: 'project',
        title: "Zeddie",
        description: `A web application for kids' reading and learning. Features include a storybook section, quiz section for knowledge testing, games section, and profile section for tracking progress and achievements.`,
        link: "https://zedie-4353b.web.app/",
        github: "https://github.com/AbrahamTerfie"
    },
    {
        id: 5,
        type: 'project',
        title: "Fashion Magazine",
        description: `Website for a fashion publication company.`,
        link: "https://magazine-e683b.firebaseapp.com/",
        github: "https://github.com/AbrahamTerfie"
    }
]